module.exports = __webpack_public_path__ + "r-v3/img/ico_modify_white.710385c1.svg";